/**
 * Defines a collection of Queue Notification objects.
 */
import Backbone from 'backbone';

import QueueNotification from 'models/device/QueueNotification';

var QueueNotifications = Backbone.Collection.extend({
    model: QueueNotification,

    backend: 'gcapi',

    url: function() {
        return '/device-service/devicemessage/messages';
    },

    parse: function(response) {
        // Need to see if there is more then one software update per device
        var softwareHeaderMap = {};
        for (var i = 0; i < response.messages.length; i++) {
            if (response.messages[i].messageType === 'software-update') {
                if (softwareHeaderMap[response.messages[i].deviceId] == null) {
                    softwareHeaderMap[response.messages[i].deviceId] = 0;
                }
                softwareHeaderMap[response.messages[i].deviceId]++;
            }
        }

        // when do we display the software header (groupName)?
        // Modify data for view
        for (var i = 0; i < response.messages.length; i++) {
            if (response.messages[i].messageType === 'software-update') {
                if (softwareHeaderMap[response.messages[i].deviceId] >= 1) {
                    // Used for sorting. Always should be at the bottom of the widget
                    response.messages[i].metaData.groupName = 'zzzzz-software-update';
                }
                response.messages[i].metaData.priority = 9999; // Lowest priority
                response.messages[i]['softwareUpdateCount'] = softwareHeaderMap[response.messages[i].deviceId];
            } else {
                response.messages[i]['messageName'] = response.messages[i].metaData.messageName;
                response.messages[i]['messageUrl'] = response.messages[i].metaData.messageUrl;
            }

            response.messages[i]['groupName'] =
                response.messages[i].metaData.groupName === '' ? null : response.messages[i].metaData.groupName;
            response.messages[i]['priority'] = response.messages[i].metaData.priority;

            delete response.messages[i].metaData.deviceName;
            delete response.messages[i].metaData.groupName;
            delete response.messages[i].metaData.priority;
        }

        return response.messages;
    },

    removeGroup: function(deviceId, groupName, options) {
        var that = this;
        var removeGroupOptions = {
            url: this.url() + '/' + deviceId + '/' + groupName,
            success: function() {
                that.fetch({
                    success: function() {
                        if (options.hasOwnProperty('success')) {
                            options.success();
                        }
                    }
                });
            },
            error: function(xHR) {
                if (options.hasOwnProperty('error')) {
                    options.error(xHR);
                }
            }
        };
        Backbone.sync('delete', this, removeGroupOptions);
    },

    /*
    Sends all of the models at once to the server.
    @param extra - anything extra you want to get when the event fires.
     */
    sendAll: function(extra) {
        // 200 workouts - 500 - 600 milliseconds in Chrome
        //            this.startTime = new Date().getTime();
        var that = this;
        var options = {
            url: this.url(),
            contentType: 'application/json; charset=UTF-8',
            data: JSON.stringify(this),
            success: function() {
                //                    console.log("sendAll - Completed in " + (new Date().getTime() - that.startTime) + " ms.");
                that.trigger('sendAll', {
                    numberSent: that.length,
                    success: true,
                    extra: extra
                });
            },
            error: function(xHR) {
                //                    console.log("sendAll - Completed in " + (new Date().getTime() - that.startTime) + " ms.");
                that.trigger('sendAll', { numberSent: 0, success: false, xHR: xHR });
            }
        };
        Backbone.sync('create', this, options);
    },

    /*
    Iterates through the models and sends them all one at a time.
    Once all of the models have been sent this will fire a sendEach event.
     */
    sendEach: function() {
        // 200 workouts - 1100 - 1200 milliseconds in Chrome
        this.startTime = new Date().getTime();
        var sentCount = 1;
        var that = this;
        for (var i = 0; i < this.length; i++) {
            var model = this.models[i];
            model.save(model.attributes, {
                success: function() {
                    if (that.length > 0 && sentCount >= that.length) {
                        console.log('sendEach - Completed in ' + (new Date().getTime() - that.startTime) + ' ms.');
                        that.trigger('sendEach', sentCount);
                    }
                    sentCount++;
                },
                error: function() {
                    if (that.length > 0 && sentCount >= that.length) {
                        console.log('sendEach - Completed in ' + (new Date().getTime() - that.startTime) + ' ms.');
                        that.trigger('sendEach', sentCount);
                    }
                    sentCount++;
                }
            });
        }
    },

    initialize: function() {}
});

export default QueueNotifications;
